import { defineComponent as _defineComponent } from 'vue'
import InDmHeader from '@/client/components/_molecules/in_dm_header'

interface Props {
  pictureUrl: string | null
  screenName: string
}

export default /*#__PURE__*/_defineComponent({
  __name: 'InDmFrame',
  props: {
    pictureUrl: null,
    screenName: null
  },
  setup(__props: any) {



return { __sfc: true,InDmHeader }
}

})